import * as angular from "angular";

angular
  .module('bringoz.admin.iam')
  .constant('ServiceAccounts_PN', {
    database: 'serviceAccount',
    isBranchEntity: false
  });
